function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M28.67,2.44H12.87A3.17,3.17,0,0,0,9.71,5.59V34a3.17,3.17,0,0,0,3.16,3.16h15.8A3.17,3.17,0,0,0,31.83,34V5.59a3.16,3.16,0,0,0-3.16-3.15m0,28.42H12.87V8.75h15.8Z",
    style: {
      fill: "#62a3ef"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.a38ce74a0bb86c4a0dcdb949ea40a6a4.svg";
export { ForwardRef as ReactComponent };